import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import React from 'react';
import type { ColorValue } from 'react-native';
import { Pressable } from 'react-native';

export function SelectionHeaderAction({
  color,
  icon,
  label,
  onPress,
}: {
  color: ColorValue;
  icon: React.ReactNode;
  label: string;
  onPress: () => void;
}) {
  return (
    <Pressable
      accessibilityLabel={label}
      accessibilityRole="button"
      hitSlop={8}
      onPress={onPress}
      style={({ pressed }) => ({ opacity: pressed ? 0.6 : 1 })}
    >
      <Row alignItems="center" gap="spacing.general.x1">
        {icon}
        <Text fontWeight="600" style={{ color }} variant="bodyBase">
          {label}
        </Text>
      </Row>
    </Pressable>
  );
}
